// Currency catalog — display only. Real charge happens at gateway.
export const CURRENCIES = {
  USD: { code: "USD", symbol: "$", flag: "🇺🇸", name: "US Dollar", price: 50, mrp: 499 },
  EUR: { code: "EUR", symbol: "€", flag: "🇪🇺", name: "Euro", price: 49, mrp: 469 },
  INR: { code: "INR", symbol: "₹", flag: "🇮🇳", name: "Indian Rupee", price: 4755, mrp: 47455 },
};

// Map browser locale country → currency
const COUNTRY_TO_CCY = {
  IN: "INR",
  AT: "EUR", BE: "EUR", BG: "EUR", HR: "EUR", CY: "EUR", CZ: "EUR", DK: "EUR",
  EE: "EUR", FI: "EUR", FR: "EUR", DE: "EUR", GR: "EUR", HU: "EUR", IE: "EUR",
  IT: "EUR", LV: "EUR", LT: "EUR", LU: "EUR", MT: "EUR", NL: "EUR", PL: "EUR",
  PT: "EUR", RO: "EUR", SK: "EUR", SI: "EUR", ES: "EUR", SE: "EUR",
};

export function detectCurrency() {
  if (typeof navigator === "undefined") return "USD";
  const locales = [navigator.language, ...(navigator.languages || [])];
  for (const loc of locales) {
    const country = (loc || "").split("-")[1];
    if (country && COUNTRY_TO_CCY[country.toUpperCase()]) {
      return COUNTRY_TO_CCY[country.toUpperCase()];
    }
  }
  return "USD";
}

export function fmt(n, ccy = "USD") {
  const c = CURRENCIES[ccy] || CURRENCIES.USD;
  const formatted = ccy === "INR"
    ? n.toLocaleString("en-IN")
    : n.toLocaleString("en-US");
  return `${c.symbol}${formatted}`;
}
